import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import ApplicationAccessMenu from './container/ApplicationAccessMenu';
import '../applicationMenu.scss';
import * as AssetTypes from './AssetTypes';
import { setAssetTypeSelectionActionCreator } from './redux/actions/AssetTypesActions';
import { getUserRole } from '../user/redux/selectors/UserDataSelectors';
import { getAssetType } from './redux/selectors/AssetTypesSelectors';
import { fetchUserDataRequestActionCreator } from '../user/redux/actions/UserActions';
import { resetGlobalEndDateSelectionActionCreator, resetGlobalStartDateSelectionActionCreator } from '../selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';
import {
  getGlobalPresetImpcRequestActionCreator,
  getGlobalPresetOperatorRequestActionCreator,
} from '../selection-criteria/global-preset/redux/actions/GlobalPresetPerAssetTypeActions';

class ApplicationAccessMenuContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetTypes: AssetTypes,
    };
    this.props.fetchUserDataRequestActionCreator();
    this.props.setAssetTypeSelectionActionCreator();
    this.setTitle = this.setTitle.bind(this);
  }

  componentDidMount() {
    this.setTitle();
  }

  componentDidUpdate() {
    this.props.resetGlobalStartDateSelectionActionCreator();
    this.props.resetGlobalEndDateSelectionActionCreator();
    this.setTitle();
  }

  setTitle() {
    const { intl } = this.props;
    document.title = intl.formatMessage({ id: 'app.title2' });
  }

  setAssetType = (type) => {
    this.props.setAssetTypeSelectionActionCreator(type);
    this.props.getGlobalPresetImpcRequestActionCreator(type);
    this.props.getGlobalPresetOperatorRequestActionCreator(type);
  };

  render() {
    const { intl } = this.props;

    return (
      <div className="application-menu-content">
        {this.state.assetTypes.map((asset) => (
          this.props.userRole.map((role) => (
            role.includes((asset.type).toUpperCase()) && (
              <section className="section" key={Math.random()}>
                <div className="asset-types">
                  <ApplicationAccessMenu
                    name={asset.name}
                    type={asset.type}
                    imgSrc={asset.imgSrc}
                    getSelectedAssetType={() => {
                      this.setAssetType(asset.type);
                      document.title = intl.formatMessage(
                        { id: 'app.title3' },
                        { context: asset.name },
                      );
                    }}
                  />
                </div>
              </section>
        )))))}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userRole: getUserRole(state),
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setAssetTypeSelectionActionCreator,
  fetchUserDataRequestActionCreator,
  resetGlobalStartDateSelectionActionCreator,
  resetGlobalEndDateSelectionActionCreator,
  getGlobalPresetImpcRequestActionCreator,
  getGlobalPresetOperatorRequestActionCreator,
}, dispatch);

ApplicationAccessMenuContainer.propTypes = {
  setAssetTypeSelectionActionCreator: PropTypes.func,
  fetchUserDataRequestActionCreator: PropTypes.func,
  userRole: PropTypes.arrayOf(PropTypes.string),
  resetGlobalStartDateSelectionActionCreator: PropTypes.func,
  resetGlobalEndDateSelectionActionCreator: PropTypes.func,
  getGlobalPresetOperatorRequestActionCreator: PropTypes.func,
  getGlobalPresetImpcRequestActionCreator: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ApplicationAccessMenuContainer));
